import { useEffect } from 'react';

import './freshworksWidgetStyle.sass';

declare global {
  interface Window {
    fwSettings: any;
    FreshworksWidget: any;
  }
}

type Props = { widgetId: number };

function FreshworksWidget({ widgetId }: Props) {
  useEffect(() => {
    if (typeof window.FreshworksWidget !== 'function') {
      const n: any = function () {
        n.q.push(arguments);
      };
      n.q = [];
      window.FreshworksWidget = n;
    }

    window.fwSettings = {
      widget_id: widgetId,
      position: {
        horizontal: 'left',
        vertical: 'bottom',
      },
    };

    const script = document.createElement('script');
    script.src = `https://mec-widget.freshworks.com/widgets/${widgetId}.js`;
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [widgetId]);

  return null;
}

export default FreshworksWidget;
